// The only place the web app touches browser storage. Only `ui.*` preferences live here;
// assessment data always comes from the API (see CLAUDE.md).

type Prefs = {
  'ui.lang': 'vi' | 'en';
  'ui.collapseAssessed': boolean;
  'ui.heatmapMode': 'groups' | 'areas' | 'table';
  /** The period reminder hidden last, as "<periodId>:<kind>"; it comes back for the next one. */
  'ui.dismissedNotice': string;
  /** Moments already celebrated on this device (keys from lib/celebrations.ts). */
  'ui.celebrated': string[];
};

export function readPref<K extends keyof Prefs>(key: K): Prefs[K] | undefined {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? undefined : (JSON.parse(raw) as Prefs[K]);
  } catch {
    return undefined;
  }
}

export function writePref<K extends keyof Prefs>(key: K, value: Prefs[K]): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Private mode or storage disabled: preferences just don't persist.
  }
}
